<template>
    <div class="modal fade fill-in" id="deleteIBModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header clearfix text-left">
                    <div class="alert alert-danger" v-if="errorMessage">
                        <button type="button" class="close" @click="errorMessage = null">
                            <span aria-hidden="true">×</span>
                            <span class="sr-only">Close</span>
                        </button>
                        {{ errorMessage }}
                    </div>
                    
                    <h4>Supprimer la relation avec l'apporteur d'affaires</h4>
                </div>
                <div class="modal-body">
                    <p style="margin-bottom: 10px;">Cette relation permet à l'apporteur d'affaires de gérer l'activité de son client à sa place.</p>
                    <div>Vous allez supprimer cette relation. En conséquence : </div>
                    <ul>
                        <li>L'apporteur d'affaires ne pourra plus agir pour le compte du client.</li>
                        <li>
                            Si aucun utilisateur n'est associé au client, l'email du premier représentant légal va être utilisé et défini en tant que email associé. 
                            Merci de bien vouloir vérifier l’exactitude de celui-ci avant de continuer.
                        </li>
                    </ul>
                    <p style="font-weight: bold;">Etes vous certain de vouloir supprimer cette relation ?</p>
                </div>
                <div class="modal-footer">
                    <button type="button" 
                        @click="$emit('confirm')"
                        class="btn btn-primary btn-cons pull-left inline"
                    >Supprimer la relation</button>
                    <button type="button" 
                        class="btn btn-default btn-cons no-margin pull-left inline"
                        @click="$emit('cancel')"
                    >Annuler</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
    export default {
        data () {
            return {
                errorMessage: null,
            }
        },

        mounted () {
            $(this.$el).modal()
        },

        beforeDestroy () {
            $(this.$el).modal('hide')
            $('body').removeClass('modal-open')
            $('.modal-backdrop').remove()
        },
    }
</script>

<style lang="scss" scoped>
    ul {
        list-style: disc inside none;

        li { 
            list-style-type: disc;
        }
    }
</style>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/DeleteIBModal.vue